import * as React from "react";
import AppUtils from "../../utils/AppUtils";
import { ORION_IMG_URL } from "../../utils/AppConstants";

interface ILogoutPromptProps {
    navigateToDashboard: () => void
}

class LogoutPrompt extends React.Component<ILogoutPromptProps, {}> {
    logout = (e: any) => {
        e.preventDefault();
        window.onbeforeunload = null;
        AppUtils.logout();
    };

    render() {
        return (
            <div className={"prescription-successful-save-container"}>
                <div className="patient-image-container">
                    <img className="patient-image" src={ORION_IMG_URL + "default-user-image.png"}/>
                </div>

                <div className="prescription-save-successful-label">
                    Seems like your appointment is complete. Would you like to logout?
                </div>
                <div className={"footer"}>
                    <div className="save-button collapsible-card button-container">
                        <input className="card-primary-action" type="button" value="Logout" onClick={this.logout}/>
                        <input
                            className="card-primary-action proceed-to-case-summary-button"
                            type="button"
                            value="Proceed to Next Consultation"
                            onClick={this.props.navigateToDashboard}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default LogoutPrompt;